import "./App.css";
import "./app/common/styles/scrollbar.styles.css";
import "./app/common/styles/auth.form.styles.css";
import "./app/common/styles/media.queries/general.media.queries.css";
import "./app/common/styles/border.styles.css";
import "./app/common/styles/card.styles.css";
import "./app/common/styles/dropdown.styles.css";
import "./app/common/styles/icons.styles.css";
import "./app/common/styles/label.styles.css";
import "./app/common/styles/margin.styles.css";
import "./app/common/styles/modals.styles.css";
import "./app/common/styles/accrodion.styles.css";
import "./app/common/styles/text.styles.css";
import "./app/common/styles/printing.styles.css";
import "./app/common/styles/ul.styles.css";
import "./app/common/styles/badge.styles.css";
import "./app/common/styles/alerts.styles.css";
import "react-toastify/dist/ReactToastify.css";
import { AdminRoutes, CommonRoutes } from "./app/routes";
import UserRoutes from "./app/routes/user.routes";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { clearStorage, getStorage } from "./app/utils/storage";
import { jwtDecode } from "jwt-decode";
import { Toaster } from "react-hot-toast";
import InactivityTracker from "./app/components/InactivityTracker";
import { joinRoom, onNotification } from "./app/utils/socket";
import BookingPrompt from "./app/components/BookingPrompt";
import { setUnreadCount, addInAppNotification } from "./app/actions/InAppNotification";
import api from "./app/utils/api";

const API_URL = process.env.REACT_APP_BBMS_BASE_API;

function App() {
  const dispatch = useDispatch();

  useEffect(() => {
    let pollInterval = null;

    const fetchUnreadCount = async (userId) => {
      try {
        const res = await api.get(`${API_URL}/notification/unread-count`, {
          params: { account: userId },
        });
        const count = res.data?.count || 0;
        dispatch(setUnreadCount(count));
      } catch {
        /* ignore */
      }
    };

    const init = async () => {
      const user = await getStorage();
      if (!user || !user.token) return;

      const decodedToken = jwtDecode(user.token);
      const currentTime = Date.now() / 1000;

      if (decodedToken?.exp && decodedToken.exp < currentTime) {
        clearStorage();
        window.location.href =
          user.accountType === "donor" ? "/login" : "/admin-login";
        return;
      }

      if (user.account_type === "donor" || user.role === "donor") return;

      // Fetch unread count now and poll every 60 seconds
      await fetchUnreadCount(user.id);
      pollInterval = setInterval(() => fetchUnreadCount(user.id), 60_000);

      // Connect socket for real-time notifications (bonus when socket.io-client available)
      try {
        await joinRoom(user.id);
        await onNotification((data) => {
          dispatch(addInAppNotification(data));
        });
      } catch {
        /* socket.io-client not available — polling handles updates */
      }
    };

    init();

    return () => {
      if (pollInterval) clearInterval(pollInterval);
    };
// eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="App">
      <InactivityTracker />
      <CommonRoutes />
      <AdminRoutes />
      <UserRoutes />
      <BookingPrompt />
      <Toaster />
    </div>
  );
}

export default App;
